import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
    const location = useLocation();
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    // Kiểm tra xem người dùng đã đăng nhập và có role admin không
    if (!token || user.role !== 'admin') {
        // Chuyển hướng về trang đăng nhập và lưu lại URL hiện tại
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default PrivateRoute; 